/**
 * @generated SignedSource<<192c91cb38e12db636528f6b456890aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertLearnosityPracticeProblemsSessionInput = {
  input: UpsertLearnosityPracticeProblemsSessionsInput;
};
export type UpsertLearnosityPracticeProblemsSessionsInput = {
  activityId: string;
  isActive: boolean;
  sessionCompletedOn?: any | null | undefined;
  sessionId: any;
  sessionStartedOn: any;
  skillId: string;
  studentId: string;
};
export type PracticeProblemsSessionMutation$variables = {
  input: UpsertLearnosityPracticeProblemsSessionInput;
};
export type PracticeProblemsSessionMutation$data = {
  readonly upsertLearnosityPracticeProblemsSession: {
    readonly learnosityPracticeProblemsSessionNode: {
      readonly id: string;
      readonly sessionId: any;
    } | null | undefined;
  };
};
export type PracticeProblemsSessionMutation = {
  response: PracticeProblemsSessionMutation$data;
  variables: PracticeProblemsSessionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertLearnosityPracticeProblemsSessionPayload",
    "kind": "LinkedField",
    "name": "upsertLearnosityPracticeProblemsSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LearnosityPracticeProblemsSessionNode",
        "kind": "LinkedField",
        "name": "learnosityPracticeProblemsSessionNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PracticeProblemsSessionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PracticeProblemsSessionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "149baeb49362d3d1f1672eb15dc40e37",
    "id": null,
    "metadata": {},
    "name": "PracticeProblemsSessionMutation",
    "operationKind": "mutation",
    "text": "mutation PracticeProblemsSessionMutation(\n  $input: UpsertLearnosityPracticeProblemsSessionInput!\n) {\n  upsertLearnosityPracticeProblemsSession(input: $input) {\n    learnosityPracticeProblemsSessionNode {\n      id\n      sessionId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "daf7936edb4cebe34c2225954439aa7f";

export default node;
